import styled from "styled-components";

export const UsedDismissedIconContainer = styled.div`
  position: absolute;
  top: ${({ isVertical }) => (isVertical ? "-15px" : "5px")};
  right: ${({ isVertical }) => (isVertical ? "-12px" : "5px")};
`;
